import { useState, useEffect } from "react";
import Badge from "../../../../../components/Badge/Badge";
import { handleToast } from "../../../../../helper";

export default function ExcludeReferrerSites(props) {
  const { excludeReferrerSitesData, customizeState, setCustomizeState, nudgeData } =
    props;
  const [excludeReferrerSites, setExcludeReferrerSites] = useState(excludeReferrerSitesData);

  useEffect(() => {
    if (nudgeData) {
      const excludeReferrerSites = nudgeData?.nudgeTrafficSources?.customizeProperties?.excludeReferrerSites || [];

      if (excludeReferrerSites) {
        let tempReferrers = excludeReferrerSites?.propertyValue?.length;
        if (tempReferrers) {
          setExcludeReferrerSites(excludeReferrerSites.propertyValue);
        }
      }
    }
  }, [nudgeData]);

  useEffect(() => {
    let state = {
      ...customizeState,
      nudgeTrafficSources: {
        ...customizeState["nudgeTrafficSources"],
        excludeReferrerSites,
      },
    };
    setCustomizeState(state);
  }, [excludeReferrerSites]);

  function handleDeleteReferrer(title) {
    // remove referrer
    const newReferrerSites = excludeReferrerSites.filter(
      (referrerSite) => referrerSite !== title
    );
    setExcludeReferrerSites(newReferrerSites);
  }

  return (
    <div className="p-4 space-y-3">
      <h3 className="text-lg font-bold">Exclude Referrer Site URLs: </h3>
      <div className="">
        {excludeReferrerSites?.length > 0 ? (
          <div className="my-1 flex flex-wrap gap-3 max-w-5xl">
            {excludeReferrerSites?.map((referrerSite, index) => {
              if (referrerSite === "HandleEmptyArrayValue") return null;
              return (
                <Badge
                  key={referrerSite}
                  title={referrerSite}
                  onClose={handleDeleteReferrer}
                  index={index}
                />
              )
              
            })}
          </div>
        ) : null}
      </div>
      <InputBadge
        referrerSites={excludeReferrerSites}
        setReferrerSites={setExcludeReferrerSites}
      />
    </div>
  );
}

function InputBadge({ referrerSites, setReferrerSites }) {
  const [title, setTitle] = useState("");

  async function handleSaveReferrer() {
    // check for duplicate
    if (referrerSites.includes(title)) {
      handleToast("error", "Duplicate referrer site");
      return;
    }
    // check for empty
    if (title === "") {
      handleToast("error", "Referrer site cannot be empty");
      return;
    }
    setReferrerSites((prev) => [...prev, title]);

    setTitle("");
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSaveReferrer();
    }
  };

  return (
    <div className="Badge px-4 py-3 flex flex-col sm:flex-row gap-3 lg:gap-5 items-center rounded-md border-2 bg-opacity-5 border-indigo-500 bg-indigo-500 text-indigo-500">
      <input
        onKeyDown={handleKeyPress}
        onChange={(e) => setTitle(e.target.value)}
        className="text-md font-semibold outline-none rounded-lg bg-transparent border-r border-inherit flex-grow"
        placeholder="site.com (enter referrer site domain)"
        value={title}
      />
      <button
        className="px-4 py-1.5 text-lg text-white bg-indigo-500 rounded-md cursor-pointer"
        onClick={handleSaveReferrer}
      >
        Add
      </button>
    </div>
  );
}
